import { Controller } from "@hotwired/stimulus"

// Attached to the adresar search <form>, which targets a <turbo-frame>.
// Typing simply submits the form after a short pause; Turbo swaps the frame.
// Enter, or no JavaScript at all, submits the same form as a normal page.
export default class extends Controller {
  search() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.element.requestSubmit(), 220)
  }

  disconnect() {
    clearTimeout(this.timer)
  }
}
